import { Icon } from "@iconify/react";
import { ScreenContainerControl } from "doshx_controls_web";
import React, { Fragment } from "react";
export const Breadcrumb = (props) => {
    const { items, title } = props;
    return (React.createElement(ScreenContainerControl, { className: "rounded-b-xl bg-light-gray md:max-w-full" },
        React.createElement("div", { className: "w-full min-h-[128px] px-4 py-8" },
            React.createElement("div", { className: "flex flex-col gap-1" },
                React.createElement("div", { className: "flex gap-2 text-sm text-dark-gray" }, items.map((item, index) => (React.createElement(Fragment, { key: item.label },
                    React.createElement("div", { className: item.active ? "text-primary" : "" }, item.label),
                    index < items.length - 1 && (React.createElement("div", { className: "my-auto" },
                        React.createElement(Icon, { icon: "lucide:chevron-right", width: "16", height: "16" }))))))),
                React.createElement("div", { className: "text-3xl text-primary font-semibold" }, title)))));
};
